import React from 'react'
import Hero from './Sections/Hero/Hero'
import Subservices from './Sections/Subservices/Subservices'
import AppComparison from './Sections/AppComparison/AppComparison'
import CaseStudies from '../../Home/Components/CaseStudies'
import ProcessSection from './Sections/ProcessSection/ProcessSection'
import ClientSpeak from '../../Home/Components/ClientSpeak'
import Footer from '../../../Components/Footer/Footer'
import Navigation from '../../../Components/Navigation/Navigation'
import uxImage from '../../../assets/images/ux-ui.png'
import Industries from './Sections/Industries/Industries'
import GetQuote from '../../../Components/GetQuote/GetQuote'
import Contect from '../../Home/Components/Contect'

const UiUx = () => {

    const homeContent = {
        title: "Craft Exceptional User Experiences That Drive Conversions",
        description: "Elevate your brand with KoolMind's award-winning design team, creating memorable digital experiences that resonate with Southeast Asian audiences! Expert designers delivering results across Singapore, Malaysia, Thailand and India.",
        image: uxImage,
        breadcrumb: "UI/UX",
        d1: "Ready to Captivate Your Users?",
        d2: "Collaborate with creative professionals who understand user psychology!",
        b: "Design With Us Today"
    }

    const subservicesTitles = {
        header: "We create compelling visual experiences that connect brands with their target audiences effectively.",
        subservices: [
            {
                iconFileName: "s6.svg",
                title: "User Experience Research & Strategy",
                subtitle: ""
            },
            {
                iconFileName: "s8.svg",
                title: "Interactive Prototype Development",
                subtitle: ""
            },
            {
                iconFileName: "s9.svg",
                title: "Design System Architecture",
                subtitle: ""
            },
            {
                iconFileName: "s10.svg",
                title: "Conversion Rate Optimization ",
                subtitle: ""
            },
            {
                iconFileName: "s11.svg",
                title: "Accessibility & Inclusive Design",
                subtitle: ""
            },
            {
                iconFileName: "s12.svg",
                title: "Brand Identity & Visual Guidelines",
                subtitle: ""
            },
            {
                iconFileName: "s13.svg",
                title: "Usability Testing & Analytics",
                subtitle: ""
            },
            {
                iconFileName: "s14.svg",
                title: "Design Consultation & Workshops",
                subtitle: ""
            }
        ]
    }

    const compareHeader = {
        title: "Difference between Responsive Design & Adaptive Design",
        description: "Understand which design methodology provides better user engagement, ensures consistent experiences, and maximizes accessibility across devices!"
    }

    const diff1 = {
        title: "Responsive Web Design",
        features: [
            { text: "Fluid layouts for all screen sizes" },
            { text: "Consistent visual hierarchy maintained" },
            { text: "Single codebase for all devices" },
            { text: "Cost-effective maintenance approach" },
            { text: "Faster development timeline" },
            { text: "Automatic content adjustment" },
            { text: "Seamless user experience" },
            { text: "Simplified content management" },
            { text: "Future-proof design solution" },
            { text: "Excellent performance optimization potential" }
        ]
    }

    const diff2 = {
        title: "Adaptive Web Design",
        features: [
            { text: "Device-specific layout optimization" },
            { text: "Targeted user experience delivery" },
            { text: "Multiple design versions required" },
            { text: "Precise control over presentations" },
            { text: "Increased development complexity" },
            { text: "Customized functionality per device" },
            { text: "Ideal for specific user journeys" },
            { text: "Higher maintenance requirements" },
            { text: "Complex content synchronization" }
        ]
    }

    const processSection = {
        title: "Design Excellence",
        description: "Award-winning agencies across Asia trust KoolMind's design philosophy. We combine creative innovation with data-driven insights. Our structured 6-step methodology ensures designs that not only look stunning but deliver exceptional business outcomes.",
        steps: [
            {
                title: "User Research",
                description: "We conduct extensive user interviews and analyze behavioral patterns comprehensively.",
                icon: "s6.svg"
            },
            {
                title: "Strategy Development",
                description: "Our team develops targeted design strategies aligned with business objectives.",
                icon: "s7.svg"
            },
            {
                title: "Concept Creation",
                description: "Creative professionals develop innovative concepts through collaborative design sessions.",
                icon: "s8.svg"
            },
            {
                title: "Design Execution",
                description: "We craft pixel-perfect designs optimized for user engagement and conversion.",
                icon: "s9.svg"
            },
            {
                title: "Prototype Testing",
                description: "Interactive prototypes undergo rigorous testing with real users for validation.",
                icon: "s10.svg"
            },
            {
                title: "Launch Support",
                description: "Ongoing design optimization and performance monitoring ensure continued success.",
                icon: "s11.svg"
            }
        ]
    }

    return (
        <div>
            <Navigation offer={true} />
            <Hero homeContent={homeContent} />
            <Subservices subservicesTitles={subservicesTitles} />
            <AppComparison compareHeader={compareHeader} diff1={diff1} diff2={diff2} />
            <ProcessSection processSection={processSection} />
            <CaseStudies />
            <Industries />
            <ClientSpeak />
            <GetQuote />
            <Contect />
            <Footer />
        </div>
    )
}

export default UiUx
